//import './guides';
import './directives';
import './rooms';